
import { useI18n } from "vue-i18n/index";
import { defineComponent, inject, ref } from "vue";

export default defineComponent({
    setup(){
        const { t } = useI18n();
        const altura = screen.height - 220;
        const serverFile = ref<any>(process.env.VUE_APP_REPO)
        const urlFile = inject('urlFile')
        const open_dialog_view_file = inject('open_dialog_view_file')

        return {
            t,
            altura,
            serverFile,
            urlFile,
            open_dialog_view_file
        }
    }
    
})
